import AdminSwitch from "../AdminSwitch/AdminSwitch";

import { useNavigate } from "react-router-dom";
import { logout } from "../../auth";
import AdminSection from "../AdminSection/AdminSection";
import { useEffect, useState } from "react";
import { get, post } from "../../services/api";
import CardCadastroMetasServico from "../CardCadastroMetasServico/CardCadastroMetasServico";

import "./MetasServicoCadastro.css"

export default function MetasServicoCadastro({ modoInsercao, setModoInsercao, filtrosValue, limparFiltros, setNotifier, methods, isArrayVazio, isSegundaEtapaDesabilitada }) {

    const [ authTokenState, setAuthTokenState ] = useState(null);
    const navigate = useNavigate();

    const { handleSubmit, setValue, reset } = methods;

    const [ tiposServico, setTiposServico ] = useState([]);
    async function setTiposServicoWithRequest(authToken) {
        try {
            const servicos = await get('admin/painelbordo/tipos-servico', null, authToken);
            
            setTiposServico(servicos);

            return servicos;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    const METODO_PERCENTUAL = 'percentual';
    const METODO_ABSOLUTO = 'absoluto';

    const handleMudarModoInsercao = () => {
        reset();
        if(modoInsercao == METODO_PERCENTUAL){
            setModoInsercao(METODO_ABSOLUTO);
        } else {
            setModoInsercao(METODO_PERCENTUAL);
        }
    }

    useEffect(() => {
        const authToken = localStorage.getItem("adminToken")

        if(authToken == null) {
            logout();
            navigate("/login");
            return;
        }

        setAuthTokenState(authToken);
        setTiposServicoWithRequest(authToken);
    }, []);

    const onSubmit = async (data) => {
        const idUsuarioAtual = localStorage.getItem("idusuario");
        const authToken = localStorage.getItem("adminToken");

        if(typeof idUsuarioAtual === 'undefined') {
            logout();
        } else{
            const valores = Object.entries(data).map(([ key, values ]) => ({
                idtiposervico: Number(key),
                absoluto: values.absoluto,
                percentual: values.percentual
            }));
            
            /**Validações manuais*/
            if(filtrosValue.cluster == null && filtrosValue.regiao == null && filtrosValue.filial == null){
                setNotifier(false, "Nenhuma localidade escolhida!");
                return;
            }

            if(typeof valores.find(tipoServico => (
                isInputVazio(tipoServico.absoluto)) &&
                isInputVazio(tipoServico.percentual)
            ) !== 'undefined'){
                setNotifier(false, "Valores incorretos!");
                return;
            }
            /** */
            const requisicao = {
                id_clusters: filtrosValue.cluster,
                id_regioes: filtrosValue.regiao,
                idfiliais: filtrosValue.filial,

                mes: Number(filtrosValue.mes.value),
                ano: filtrosValue.ano,
                idusuario: Number(idUsuarioAtual),

                metas: valores.map(tipoServico => ({
                    idtiposervico: Number(tipoServico.idtiposervico),
                    valor: Number((modoInsercao == METODO_PERCENTUAL
                        ?  tipoServico.percentual
                        :  tipoServico.absoluto).replaceAll('.', '').replace(',', '.')),
                    isPercentual: modoInsercao == METODO_PERCENTUAL,
                }))
            }

            const { response } = await post('/admin/painelbordo/metas-servico', requisicao, authToken);

            if(response?.status >= 400){
                setNotifier(false, response.data.Error)
            }
            else{
                setNotifier(true, 'Metas de serviço alteradas com sucesso');
            }
            limparInputs();
        }
    }

    const handleCancelar = (e) => {
        e.preventDefault();
        limparInputs();
    }

    //Utils
    function limparInputs(type = 'all') {
        switch(type) {
            case 'all':
                limparFiltros();
                setModoInsercao('percentual');
                
            case 'metas':
                tiposServico.forEach(tipoServico => {
                    setValue(`${tipoServico.idtiposervico}.absoluto`, null);
                    setValue(`${tipoServico.idtiposervico}.percentual`, null);
                })
        }
    }
    function isInputVazio(input) {
        return (
            typeof input === 'undefined' ||
            input === null ||
            input === ''
        );
    }

    return <>
        <AdminSection
            etapa={2} titulo={'Cadastrar Metas Serviços'}
            disabled={isSegundaEtapaDesabilitada()}
            acoes={<>
                <div className="flex flex-col items-end gap-1">
                    <p style={{color: "#808080"}}>Valor {modoInsercao}</p>
                    <AdminSwitch checked={modoInsercao == METODO_ABSOLUTO} onChange={handleMudarModoInsercao} size="md"/>
                </div>
            </>}
        >   
            <form style={{padding: "24px"}} onSubmit={handleSubmit(onSubmit)}>
                <div 
                    className="admin-metas-servico"
                >
                    {!isArrayVazio(tiposServico) && tiposServico.map((tipoServico, index) =>
                        <CardCadastroMetasServico 
                            key={index} 
                            tipoServico={tipoServico} 
                            isEven={(index+1) % 2 == 0} 
                            modoInsercao={modoInsercao}
                        />
                    )}
                </div>
                <div className="flex justify-end">
                    <button className="admin-deny-btn"
                        onClick={handleCancelar}
                    >Cancelar</button>
                    <button type="submit" style={{backgroundColor: "#00925A"}} className="admin-accept-btn"
                    >Salvar</button>
                </div>
            </form>
        </AdminSection>
    </>
}